import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '@tribeplatform/react-sdk';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
export const SpacePill = ({ space }) => {
    var _a, _b;
    const { Link } = useRouter();
    if (!(space === null || space === void 0 ? void 0 : space.name)) {
        return null;
    }
    return (_jsx(Link, { href: space === null || space === void 0 ? void 0 : space.relativeUrl, className: "rounded-full", translate: "no", children: _jsx(Badge, { variant: "secondary", className: "ps-1", leadingIcon: _jsx(Avatar, { size: "xs", rounded: "md", src: (_b = (_a = space === null || space === void 0 ? void 0 : space.image) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.thumb, name: space === null || space === void 0 ? void 0 : space.name }, void 0), children: space === null || space === void 0 ? void 0 : space.name }, void 0) }, void 0));
};
//# sourceMappingURL=SpacePill.js.map